import {Card, CardContent, Grid, TextField, Typography} from "@mui/material";
import dayjs from "dayjs";
import {useTranslation} from "react-i18next";
import {Box} from "@mui/system";
import * as React from "react";

const CustomerBookingDetails = (props: any) => {
    const {t} = useTranslation("finance", {keyPrefix: "payments.payment-request"});
    const customerBookingDetails = props.customerBookingDetails;

    return (
        <Box>
            <Card variant="outlined" sx={{margin: '16px'}}>
                <CardContent>
                    <Grid container direction={'row'} rowGap={5}>
                        <Grid container item spacing={2} alignItems={'center'}>
                            <Grid item xs={12}>
                                <Typography variant={'body2'} color={'primary.light'} fontWeight={700}
                                            textTransform={'uppercase'}>
                                    {t('pages.wizard.form.title-bookingOwner')}
                                </Typography>
                            </Grid>

                        </Grid>
                        <Grid container item spacing={2} alignItems={'center'}>


                            <Grid item md={3} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails.firstName}
                                    label={t("pages.wizard.form.labelBookingOwnerName")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails.lastName}
                                    label={t("pages.wizard.form.labelBookingOwnerLastName")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails.companyName}
                                    label={t("pages.wizard.form.labelBookingOwnerBusinessName")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>

                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails?.taxCode ? customerBookingDetails.taxCode : customerBookingDetails?.vatCode ? customerBookingDetails.vatCode : ""}
                                    label={t("pages.wizard.form.labelBookingOwnerFiscalCode")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails?.siren ? customerBookingDetails.siren : customerBookingDetails?.siren ? customerBookingDetails.siren : ""}
                                    label={t("pages.wizard.form.labelSiren")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails?.siret ? customerBookingDetails.siret : customerBookingDetails?.siret ? customerBookingDetails.siren : ""}
                                    label={t("pages.wizard.form.labelSiret")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>

                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails?.siren ? customerBookingDetails.siren : customerBookingDetails?.siren ? customerBookingDetails.siren : ""}
                                    label={t("pages.wizard.form.labelSiren")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails?.siret ? customerBookingDetails.siret : customerBookingDetails?.siret ? customerBookingDetails.siren : ""}
                                    label={t("pages.wizard.form.labelSiret")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>

                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails.address}
                                    label={t("pages.wizard.form.labelBookingOwnerAddress")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>

                            <Grid item md={3} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails.email}
                                    label={t("pages.wizard.form.labelBookingOwnerEmail")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={12} xs={12}>
                                <TextField
                                    label={t("pages.wizard.form.labelBookingOwnerBirthDate")}
                                    value={customerBookingDetails?.birthDate ? dayjs(customerBookingDetails.birthDate).format("L") : ""}
                                    fullWidth
                                    disabled={true}
                                    id="birthDate"
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails.birthCity}
                                    label={t("pages.wizard.form.labelBookingOwnerBirthPlace")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails.birthProvince}
                                    label={t("pages.wizard.form.labelBookingOwnerBirthProvince")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerBookingDetails.birthCountry}
                                    label={t("pages.wizard.form.labelBookingOwnerNationality")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    )


}
export default CustomerBookingDetails;